export const THEMES = {
  klasik: {
    id: 'klasik', name: 'Klasik Terracotta', desc: 'Hangat & elegan, warna khas Naik Pelaminan',
    swatch: ['#F5EFE7', '#B8642F', '#2C3830'],
    bg: 'bg-cream-100', text: 'text-sage-700', textSoft: 'text-sage-600', muted: 'text-sage-500',
    accentText: 'text-terracotta-500', accentSoft: 'bg-terracotta-50', line: 'bg-terracotta-300',
    card: 'bg-white border-cream-200', input: 'bg-cream-50 border-cream-200',
    chipOn: 'bg-terracotta-500 border-terracotta-500 text-white', chipOff: 'bg-cream-50 border-cream-200 text-sage-600',
    button: 'bg-terracotta-500 hover:bg-terracotta-600 text-white',
    venue: 'bg-sage-700 text-white', venueBlob: 'bg-terracotta-500/30', venueBtn: 'bg-white text-sage-700 hover:bg-cream-50',
    coverOverlay: 'bg-gradient-to-b from-transparent via-cream-100/40 to-cream-100', dot1: '#B8642F', dot2: '#4A5D4F'
  },
  sage: {
    id: 'sage', name: 'Sage Garden', desc: 'Sejuk & natural dengan nuansa hijau sage',
    swatch: ['#EEF1EE', '#4A5D4F', '#D08D5B'],
    bg: 'bg-sage-50', text: 'text-sage-700', textSoft: 'text-sage-600', muted: 'text-sage-400',
    accentText: 'text-sage-600', accentSoft: 'bg-sage-100', line: 'bg-sage-300',
    card: 'bg-white border-sage-100', input: 'bg-sage-50 border-sage-100',
    chipOn: 'bg-sage-600 border-sage-600 text-white', chipOff: 'bg-sage-50 border-sage-100 text-sage-600',
    button: 'bg-sage-600 hover:bg-sage-700 text-white',
    venue: 'bg-terracotta-500 text-white', venueBlob: 'bg-white/20', venueBtn: 'bg-white text-terracotta-600 hover:bg-cream-50',
    coverOverlay: 'bg-gradient-to-b from-transparent via-sage-50/40 to-sage-50', dot1: '#4A5D4F', dot2: '#7E8E82'
  },
  midnight: {
    id: 'midnight', name: 'Midnight Elegant', desc: 'Mewah & dramatis dengan latar gelap',
    swatch: ['#2C3830', '#D08D5B', '#F5EFE7'],
    bg: 'bg-sage-700', text: 'text-cream-100', textSoft: 'text-cream-200', muted: 'text-sage-200',
    accentText: 'text-terracotta-300', accentSoft: 'bg-sage-600', line: 'bg-terracotta-300/60',
    card: 'bg-sage-600 border-sage-500', input: 'bg-sage-700 border-sage-500 text-cream-100 placeholder:text-sage-300',
    chipOn: 'bg-terracotta-400 border-terracotta-400 text-white', chipOff: 'bg-sage-700 border-sage-500 text-cream-200',
    button: 'bg-terracotta-400 hover:bg-terracotta-500 text-white',
    venue: 'bg-cream-100 text-sage-700', venueBlob: 'bg-terracotta-500/20', venueBtn: 'bg-sage-700 text-cream-100 hover:bg-sage-600',
    coverOverlay: 'bg-gradient-to-b from-transparent via-sage-700/50 to-sage-700', dot1: '#D08D5B', dot2: '#AEBBB0'
  }
};
